import { _Application, CurrentApplication } from '@organization/api/requests'
import { useApplicationIcon } from '@organization/hooks'
import { applicationTypes } from '@organization/layout/Applications/AppIcons'
import { useStyles } from '@organization/layout/Applications/Views/ListView/styles'
import { Flex, Space, Typography } from 'antd'
import classNames from 'classnames'

type Props = {
  currentApplication?: CurrentApplication
  application: _Application
}

/**
 *
 * @param currentApplication - The current application
 * @param application - The application to display
 * @description This component is used to display the application in a grid view.
 * @example
 * ```tsx
 * <GridView currentApplication={currentApplication} application={application} />
 * ```
 */

export const GridView = ({ currentApplication, application }: Props) => {
  const isSelected = currentApplication?.token === application?.token

  const appType = application?.instance_type?.type ?? ''

  const applicationIcon = useApplicationIcon(appType)

  const { styles } = useStyles({ isSelected, applicationIcon })

  const { icon: AppIcon } =
    applicationTypes[appType] ?? applicationTypes.default

  const onClick = () => {
    window.location.replace(`/apps/${appType}/${application.token}`)
  }

  return (
    <Flex
      vertical
      align="center"
      className={classNames(styles.item, styles.gridItem)}
      onClick={onClick}
    >
      <Flex vertical gap={8} align="center" className={styles.gridWrapper}>
        <Flex
          align="center"
          className={classNames(styles.icon, styles.applicationIcon)}
        >
          <AppIcon />
        </Flex>
        <Space.Compact direction="vertical">
          <Typography.Text strong id="title">
            {application?.instance_type?.name}
          </Typography.Text>
          <Typography.Text type="secondary">
            {application?.instance_type?.description}
          </Typography.Text>
        </Space.Compact>
      </Flex>
    </Flex>
  )
}
